import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Checkout from "@/pages/Checkout";
import PayLink from "@/pages/PayLink";
import Store from "@/pages/Store";
import Promos from "@/pages/merchant/Promos";
import Overview from "@/pages/merchant/Overview";
import Sites from "@/pages/merchant/Sites";
import Wallet from "@/pages/merchant/Wallet";
import ApiKeys from "@/pages/merchant/ApiKeys";
import Orders from "@/pages/merchant/Orders";
import Products from "@/pages/merchant/Products";
import Webhooks from "@/pages/merchant/Webhooks";
import Integration from "@/pages/merchant/Integration";
import Settings from "@/pages/merchant/Settings";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminMerchants from "@/pages/admin/AdminMerchants";
import AdminLogs from "@/pages/admin/AdminLogs";
import AdminWatcher from "@/pages/admin/AdminWatcher";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminInvites from "@/pages/admin/AdminInvites";

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-zinc-500 text-sm">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/checkout/:orderId" element={<Checkout />} />
            <Route path="/pay/:slug" element={<PayLink />} />
            <Route path="/store/:slug" element={<Store />} />
            <Route path="/app" element={<Guard role="merchant"><Layout /></Guard>}>
              <Route index element={<Overview />} />
              <Route path="sites" element={<Sites />} />
              <Route path="wallet" element={<Wallet />} />
              <Route path="api-keys" element={<ApiKeys />} />
              <Route path="orders" element={<Orders />} />
              <Route path="products" element={<Products />} />
              <Route path="promos" element={<Promos />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="integration" element={<Integration />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="/admin" element={<Guard role="admin"><Layout admin /></Guard>}>
              <Route index element={<AdminOverview />} />
              <Route path="merchants" element={<AdminMerchants />} />
              <Route path="invites" element={<AdminInvites />} />
              <Route path="logs" element={<AdminLogs />} />
              <Route path="watcher" element={<AdminWatcher />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}
